import { z } from "zod";

export const signature_schema = z.object({
	signature: z.file({
		error: "Informação obrigatória.",
	}),
});
